import { render, staticRenderFns } from "./CallScriptPublicPage.vue?vue&type=template&id=c67952ae&scoped=true&"
import script from "./CallScriptPublicPage.vue?vue&type=script&lang=js&"
export * from "./CallScriptPublicPage.vue?vue&type=script&lang=js&"
import style0 from "./CallScriptPublicPage.vue?vue&type=style&index=0&id=c67952ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67952ae",
  null
  
)

export default component.exports